<template>
 <div class="doomyoga_forget_password doomyoga-auth-container ">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto" id="doomYogaFormDiv">
          <!-- <Login titleH2="Do.OmYoga! <br> STUDIO" guard="DY" clientLink="doom_yoga" /> -->
          <ForgetPassword
            titleH2="Do.OmYoga! <br> STUDIO"
            welcomeHeader="Reset Passsword"
            welcomeSubheader="Please enter your registered email to send you an link to reset your password"
            guard="DY" clientLink="doom_yoga"
          />
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-auto">
          <div class="container " id="doomYogaImdDiv">
            <img
              class="img-fluid mx-auto"
              id="doomYogaLoginImg"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgetPassword from "@/components/auth/ForgetPassword.vue";

export default {
  name: "DoOmYogaForgetPassword",
  components: { ForgetPassword },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit forget password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/doom-yoga-fonts.css";
@import "../css/doom-yoga-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doom_yoga/auth/ForgetPasswordView.vue